import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const listCommittedOrders = {
  name: "listCommittedOrders" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema.optional(),
  }),
  output: z.object({
    items: z.array(
      z.object({
        fulfillmentGroupId: z.string().nullable(),
        orderName: z.string().nullable(),
        orderLinkId: z.string().nullable(),
        isRedoOrder: z.boolean(),
        quantity: z.number(),
        status: createEnum(FulfillmentGroupStatus).nullable(),
        locationId: locationIdFormat.schema.nullable(),
        locationName: z.string().nullable(),
      }),
    ),
    totalCommitted: z.number(),
    attributed: z.number(),
    unattributed: z.number(),
  }),
};
